import { parseOptions } from './defaults'
import { User, Auth, Basic, Node, Product, Cart, Order, Address, Province, City, App } from './modules'

class Ecommerce {
  constructor(options = {}) {
    this.init(options)
  }

  /**
   * App module getter
   */
  get App() {
    return App.init(this._options.handler)
  }

  /**
   * User module getter
   */
  get User() {
    return User.init(this._options.handler)
  }

  /**
   * User module getter
   */
  get Auth() {
    return Auth.init(this._options.handler)
  }

  /**
   * Basic module getter
   */
  get Basic() {
    return Basic.init(this._options.handler)
  }

  /**
   * Node module getter
   */
  get Node() {
    return Node.init(this._options.handler)
  }

  /**
   * Product module getter
   */
  get Product() {
    return Product.init(this._options.handler)
  }

  /**
   * Cart module getter
   */
  get Cart() {
    return Cart.init(this._options.handler)
  }

  /**
   * Order module getter
   */
  get Order() {
    return Order.init(this._options.handler)
  }

  /**
   * Address module getter
   */
  get Address() {
    return Address.init(this._options.handler)
  }

  /**
   * Province module getter
   */
  get Province() {
    return Province.init(this._options.handler)
  }

  /**
   * City module getter
   */
  get City() {
    return City.init(this._options.handler)
  }

  /**
   * Initialize package
   * @param {Object} options options
   */
  init(options = {}) {
    this._options = parseOptions(options)

    return this
  }
}

export default new Ecommerce();
